import React from 'react';
import type { HTMLAttributes } from 'react';

type Ref = HTMLDivElement;
type HTMLProps = HTMLAttributes<Ref>;
interface Props extends HTMLProps {
  children: React.ReactNode;
}

const Section = React.forwardRef<Ref, Props>(({
  children,
  ...other
}: Props, ref): JSX.Element => (
  <div ref={ref}{...other as HTMLProps}>
    <div className={'bg-white rounded-default shadow'}>
      {children}
    </div>
  </div>
));

Section.displayName = 'Section';

export default Section;
